import React, { Fragment, JSX } from 'react';
import dayjs from 'dayjs';
import { toString } from '@/helpers/common/amount';
import OrderSite from '@/model/OrderSite';
import { EventCheckout, TicketCheckout } from '../types';

interface StateProps {
  order?: OrderSite;
  events: EventCheckout[];
  tickets: TicketCheckout[];
  amountItens: number;
}

interface DispatchProps {
  toCurrency: (value: number) => string;
}

type Props = StateProps & DispatchProps;

export const OrderInformationContent: React.FC<Props> = ({
  order,
  events,
  tickets,
  amountItens,
  toCurrency,
}): JSX.Element => (
  <Fragment>
    <h2 className="font-dmsans font-normal text-neutro-b-400 text-[28px] ">Confira seu pedido</h2>
    <p className="font-dmsans text-base font-normal text-neutro-w-600 leading-[28px]">
      Confirme se o seu pedido esta correto
    </p>

    <div style={{ paddingTop: '10px' }} className=" cart-item w-full border-b border-neutro-w-200">
      {order && events && events.length > 0 && (
        <Fragment>
          <header className="grid grid-cols-1 md:grid-cols-6 items-center gap-5">
            <div className="col-start-1 col-end-1 hidden  md:block">
              <img className="w-[50px] sm:w-[115px] rounded-md" src={events[0].image} alt="Event" />
            </div>
            <div className="col-start-2 col-end-6 hidden  md:block">
              <h4 className="text-neutral-b-400 font-dmsans font-medium text-[18px] sm:text-[21px]">
                {events[0].name}
              </h4>
              <div className="flex items-center text-base ">
                <span className="font-dmsans font-normal text-neutro-w-600 uppercase text-[12px] sm:text-[18px]">
                  {dayjs(events[0].startDate).locale('pt-br').format('DD MMM')}{' '}
                </span>
                <span className="w-[6px] h-[6px] mx-2 bg-gray-300 rounded-full"></span>
                <span className="font-dmsans font-normal text-neutro-w-600 uppercase text-[12px] sm:text-[18px]">
                  {dayjs(events[0].startDate).format('HH:mm')}
                </span>
                <span className="w-[6px] h-[6px] mx-2 bg-gray-300 rounded-full text-[12px] sm:text-[18px]"></span>
                <span className="font-dmsans font-normal text-neutro-w-600">
                  {events[0].city}/{events[0].state}
                </span>
              </div>
            </div>
            <div className="col-start-1 col-end-1 block md:hidden">
              <img className="w-[115px] rounded-md" src={events[0].image} alt="Event" />
            </div>
            <div className="col-start-1 col-end-1 block  md:hidden">
              <h4 className="text-neutral-b-400 font-dmsans font-medium text-[18px] sm:text-[21px]">
                {events[0].name}
              </h4>
              <div className="flex items-center text-base ">
                <span className="font-dmsans font-normal text-neutro-w-600 uppercase text-[12px] sm:text-[18px]">
                  {dayjs(events[0].startDate).locale('pt-br').format('DD MMM')}{' '}
                </span>
                <span className="w-[6px] h-[6px] mx-2 bg-gray-300 rounded-full"></span>
                <span className="font-dmsans font-normal text-neutro-w-600 uppercase text-[12px] sm:text-[18px]">
                  {dayjs(events[0].startDate).format('HH:mm')}
                </span>
                <span className="w-[6px] h-[6px] mx-2 bg-gray-300 rounded-full text-[12px] sm:text-[18px]"></span>
                <span className="font-dmsans font-normal text-neutro-w-600">
                  {events[0].city}/{events[0].state}
                </span>
              </div>
            </div>
          </header>
          <div>
            {tickets &&
              tickets.length > 0 &&
              tickets.map(ticket => (
                <div className="flex justify-between py-4" key={`Ticket-${ticket.id}`}>
                  <div className="text-left">
                    <div className="font-dmsans font-normal text-[21px] leading-[27px] text-neutro-b-400">
                      {ticket.name}
                    </div>
                    <div className="font-dmsans font-normal text-base text-neutro-w-600">
                      <span>{`R$ ${toString(ticket.amount * ticket.value * 100)}`}</span>
                    </div>
                  </div>
                  <div className="flex justify-center items-center">
                    <div className="font-dmsans text-base text-heading px-[15px]">
                      {ticket.amount}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </Fragment>
      )}
    </div>

    <div className="mb-[20px]"></div>
    <div className="flex justify-between items-center mb-1">
      <div className="text-heading font-dmsans font-normal">
        Total de itens: <span className="font-bold">{amountItens}</span>
      </div>
    </div>
    {order && order.orderFractionalRequest && (
      <Fragment>
        <div className="flex justify-between items-center mb-1">
          <div className="text-heading font-dmsans font-normal">
            Total: <span className="font-bold">{toCurrency(order.totalValue)}</span>
          </div>
          <div className="text-heading font-dmsans font-normal">
            Pago:{' '}
            <span className="font-bold">{toCurrency(order.orderFractionalRequest.paidAmount)}</span>
          </div>
        </div>
        <div className="flex justify-between items-center mb-2">
          <div className="text-heading font-dmsans font-normal">
            Restante:{' '}
            <span className="font-bold">
              {toCurrency(order.orderFractionalRequest.remainingValue)}
            </span>
          </div>
        </div>
        <div className="flex justify-between items-center mb-1">
          <div className="text-heading font-dmsans font-normal">
            Sub total:{' '}
            <span className="font-bold">
              {order.orderFractionalRequest
                ? toCurrency(order.orderFractionalRequest.remainingValue)
                : toCurrency(order.totalValue)}
            </span>
          </div>
        </div>
        <hr className="my-5" />
        <div className="flex justify-between items-center mb-1">
          <div className="text-heading font-dmsans font-normal">
            Valor total:{' '}
            <span className="font-bold">
              {order.orderFractionalRequest
                ? toCurrency(order.orderFractionalRequest.remainingValue)
                : toCurrency(order.totalValue)}
            </span>
          </div>
        </div>
      </Fragment>
    )}
  </Fragment>
);
